// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-bottom-sheet {
  /* Override bottom sheet styles for this specific component */
}

.contact-us-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0 16px;
}

.message-section {
  margin-bottom: 16px;
}

.message-label {
  margin-bottom: 8px;
  color: var(--color-black);
}

.message-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 1.5;
  resize: vertical;
  background-color: var(--color-white);
  color: var(--color-black);
}

.message-textarea:focus {
  outline: none;
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 2px var(--accent-ring);
}

.message-textarea::placeholder {
  color: var(--color-gray);
}

.helper-text {
  margin-bottom: 16px;
  padding: 12px;
  background-color: var(--color-pastelle-blue);
  border-radius: 8px;
  border-left: 4px solid var(--color-primary-green);
}

.helper-text-content {
  color: var(--color-dark-gray);
  line-height: 1.4;
}

.contact-us-footer {
  margin-top: auto;
  padding: 16px 0;
  border-top: 1px solid var(--color-light-gray);
  flex-shrink: 0;
}

.send-button {
  width: 100%;
  height: 48px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .contact-us-content {
    padding: 0 12px;
  }
  
  .message-textarea {
    min-height: 100px;
    padding: 10px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  .helper-text {
    padding: 10px;
  }
  
  .contact-us-footer {
    padding: 12px 0;
  }
  
  .send-button {
    height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/ContactUsBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe,EAAE,yBAAyB;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".contact-us-bottom-sheet {\n  /* Override bottom sheet styles for this specific component */\n}\n\n.contact-us-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  padding: 0 16px;\n}\n\n.message-section {\n  margin-bottom: 16px;\n}\n\n.message-label {\n  margin-bottom: 8px;\n  color: var(--color-black);\n}\n\n.message-textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 12px;\n  border: 1px solid var(--color-gray);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 1.5;\n  resize: vertical;\n  background-color: var(--color-white);\n  color: var(--color-black);\n}\n\n.message-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 2px var(--accent-ring);\n}\n\n.message-textarea::placeholder {\n  color: var(--color-gray);\n}\n\n.helper-text {\n  margin-bottom: 16px;\n  padding: 12px;\n  background-color: var(--color-pastelle-blue);\n  border-radius: 8px;\n  border-left: 4px solid var(--color-primary-green);\n}\n\n.helper-text-content {\n  color: var(--color-dark-gray);\n  line-height: 1.4;\n}\n\n.contact-us-footer {\n  margin-top: auto;\n  padding: 16px 0;\n  border-top: 1px solid var(--color-light-gray);\n  flex-shrink: 0;\n}\n\n.send-button {\n  width: 100%;\n  height: 48px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .contact-us-content {\n    padding: 0 12px;\n  }\n  \n  .message-textarea {\n    min-height: 100px;\n    padding: 10px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  .helper-text {\n    padding: 10px;\n  }\n  \n  .contact-us-footer {\n    padding: 12px 0;\n  }\n  \n  .send-button {\n    height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
